import type { SurveyMetrics } from '../../../lib/surveyResults';

// Phase 6B E2 — the top-level metric card row (§6.2). Six cards: Sent, Opened,
// Started, Submitted, Pending, Page views. Pending is clickable → the Phase F
// resend flow when onResend is provided (only on open surveys with pending > 0).

export function MetricCards({ metrics, onResend }: { metrics: SurveyMetrics; onResend?: () => void }) {
  return (
    <div className="mb-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      <Card label="Sent" value={metrics.sent} />
      <Card label="Opened" value={metrics.opened} secondary={metrics.openRate} />
      <Card label="Started" value={metrics.started} />
      <Card label="Submitted" value={metrics.submitted} secondary={metrics.submitRate} />
      <Card
        label="Pending"
        value={metrics.pending}
        onClick={onResend && metrics.pending > 0 ? onResend : undefined}
      />
      <Card label="Page views" value={metrics.pageViews} />
    </div>
  );
}

function Card({
  label,
  value,
  secondary,
  onClick,
}: {
  label: string;
  value: number;
  secondary?: number | null;
  onClick?: () => void;
}) {
  const body = (
    <>
      <div className="flex items-baseline gap-1.5">
        <span className="text-2xl font-semibold text-slate-900">{value}</span>
        {secondary != null && <span className="text-xs font-medium text-slate-400">{secondary}%</span>}
      </div>
      <div className="mt-0.5 text-xs font-medium uppercase tracking-wide text-slate-500">{label}</div>
    </>
  );
  const base = 'rounded-lg border border-slate-200 bg-white px-4 py-3 text-left';
  return onClick ? (
    <button type="button" onClick={onClick} className={base + ' transition-colors hover:border-kyck-400 hover:bg-kyck-50/40'}>
      {body}
    </button>
  ) : (
    <div className={base}>{body}</div>
  );
}
